import { isAuthTokenStore } from './helpers';
import { selectAccessToken } from './selectors';
import type { AuthTokenStore } from './types';
import FingerprintJs from '@fingerprintjs/fingerprintjs';

export async function customHeaders(
  originalHeaders: Headers,
  state: AuthTokenStore,
): Promise<Headers> {
  const accessToken = selectAccessToken(state);

  const fp = await FingerprintJs.load();
  const { visitorId: fingerprint } = await fp.get();

  const headers = new Headers(originalHeaders);

  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  if (fingerprint) {
    headers.set('x-fingerprint', fingerprint);
  }

  return headers;
}

/**
 * Sets standard HTTP headers for JSON API requests. Injects the Bearer
 * Authorization token from Redux authToken state when available, and always
 * sets Content-Type and Accept defaults. Synchronous, fingerprint-free —
 * suitable for any RTK Query base query that only needs JWT injection.
 */
export const prepareAuthHeaders = (
  headers: Headers,
  { getState }: { getState: () => unknown },
): Headers => {
  const state = getState();
  if (isAuthTokenStore(state)) {
    const accessToken = selectAccessToken(state);
    if (accessToken) {
      headers.set('Authorization', `Bearer ${accessToken}`);
    }
  }
  headers.set('Content-Type', 'application/json');
  headers.set('Accept', '*/*');
  return headers;
};
